'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _acceptLanguage = require('accept-language');

var _acceptLanguage2 = _interopRequireDefault(_acceptLanguage);

var _en_US = require('./en_US');

var _en_US2 = _interopRequireDefault(_en_US);

var _zh_CN = require('./zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

var _ko_Kr = require('./ko_Kr');

var _ko_Kr2 = _interopRequireDefault(_ko_Kr);

var _zh_TW = require('./zh_TW');

var _zh_TW2 = _interopRequireDefault(_zh_TW);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocalMap = {
    'zh': _zh_CN2["default"],
    'en': _en_US2["default"],
    'ko': _ko_Kr2["default"],
    'zh-tw': _zh_TW2["default"]
};

_acceptLanguage2["default"].languages(['en', 'zh', 'ko', 'zh-tw']);

var Locale = function () {
    function Locale() {
        _classCallCheck(this, Locale);
    }

    _createClass(Locale, [{
        key: 'InitLang',
        value: function InitLang(lang, navigatorlanguage) {

            if (lang) {
                if (lang === 'chs') {
                    this.locale = 'zh';
                } else if (lang === 'cht') {
                    this.locale = 'zh-tw';
                } else if (lang === 'kor') {
                    this.locale = 'ko';
                } else {
                    this.locale = 'en';
                }
            } else {
                console.log('navigatorlanguage = ' + navigatorlanguage);
                this.locale = this.detectLocale(navigatorlanguage);
            }
        }
    }, {
        key: 'getLocal',
        value: function getLocal() {
            return this.locale;
        }
    }, {
        key: 'getLang',
        value: function getLang() {
            var retLang = 'usa';
            if (this.locale === 'zh') {
                retLang = 'chs';
            } else if (this.locale === 'zh-tw') {
                retLang = 'cht';
            } else if (this.locale === 'ko') {
                retLang = 'kor';
            } else {}

            return retLang;
        }
    }, {
        key: 'getLocalClient',
        value: function getLocalClient() {
            var localDkc = 'usa';
            var _locale = Locale.Instance.getLocal();
            if (_locale === 'zh') {
                localDkc = 'chs';
            } else if (_locale === 'zh-tw') {
                localDkc = 'cht';
            } else if (_locale === 'ko') {
                localDkc = 'kor';
            } else {
                localDkc = 'usa';
            }

            return localDkc;
        }
    }, {
        key: 'getMessage',
        value: function getMessage() {
            return LocalMap[this.locale];
        }
    }, {
        key: 'getMessagebyId',
        value: function getMessagebyId(id) {
            var message = this.getMessage();
            return message[id];
        }
    }, {
        key: 'detectLocale',
        value: function detectLocale(req) {
            var _req = _acceptLanguage2["default"].get(req);
            console.log('detectLocale = ' + _req);
            return _req || 'en';
        }
    }], [{
        key: 'GetInstance',
        value: function GetInstance() {
            if (Locale.s_instance == null) {
                Locale.s_instance = new Locale();
            }

            return Locale.s_instance;
        }
    }]);

    return Locale;
}();

Locale.s_instance = null;
exports["default"] = Locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lang/Locale.js
// module id = 298
// module chunks = 0